import { render, staticRenderFns } from "./buy-item-free-item-form.vue?vue&type=template&id=474ac115&"
import script from "./buy-item-free-item-form.vue?vue&type=script&lang=js&"
export * from "./buy-item-free-item-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports